const STORAGE_KEY = "diningGuestId";

function newGuestId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/** Stable anonymous id for table QR ordering on this device (no account). */
export function getDiningGuestId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = newGuestId();
      localStorage.setItem(STORAGE_KEY, id);
      sessionStorage.setItem(STORAGE_KEY, id);
    }
    return String(id).trim();
  } catch {
    return null;
  }
}

export function diningGuestKey() {
  const id = getDiningGuestId();
  return id ? `guest:${id}` : null;
}
